import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';
import { RestaurantShift } from '@durma-soft/gros-sdk/dist/types/restaurants';
import {
  isAxiosError,
  useAuthUserRestaurant,
  useCreateRestaurantTrackSubstituteOrderMutation,
} from '@durma-soft/gros-sdk';

import { Button } from '@/components/shared/shadcn-ui/button';

import { noop } from '@/utils/helpers';

interface GiveDefaultSubstituteMealProps {
  date: string;
  userId: number;
  shift: RestaurantShift;
  restaurantTrackLocationId: number;
  onOrderCreated?: () => void;
}

/**
 * Lets owners and managers take another substitute meal on track locations
 * where substitute selection is disabled (the default substitute food is given)
 */
export const GiveDefaultSubstituteMeal = ({
  date,
  userId,
  shift,
  restaurantTrackLocationId,
  onOrderCreated = noop,
}: GiveDefaultSubstituteMealProps) => {
  const { t } = useTranslation();
  const { id: restaurant_id } = useAuthUserRestaurant();

  const createSubstituteOrderMutation =
    useCreateRestaurantTrackSubstituteOrderMutation();

  const handleCreateSubstituteOrder = async () => {
    if (createSubstituteOrderMutation.isPending) return;
    try {
      await createSubstituteOrderMutation.mutateAsync({
        restaurant_id,
        user_id: userId,
        shift,
        date,
        restaurant_track_location_id: restaurantTrackLocationId,
      });
      toast.success(t('track.no-order.order-created-success-msg'));
      onOrderCreated();
    } catch (error) {
      if (isAxiosError(error) && error.response?.data?.message) {
        return toast.error(error.response.data.message);
      }
      toast.error(t('track.no-order.order-created-error-msg'));
    }
  };

  return (
    <Button
      onClick={handleCreateSubstituteOrder}
      isLoading={createSubstituteOrderMutation.isPending}
      className="self-start xl:h-14 text-lg xl:text-xl xl:px-8"
    >
      {t('track.no-order.give-default-substitute-meal')}
    </Button>
  );
};
